/**
 * @file   src\store\index.ts
 * @brief  This file is responsible for configuring the redux store.
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';


export const store = configureStore({
  reducer: {
    // Add reducer slices.
    adminAuth: authReducer,
  },
  // Adding the api middlewares enables caching , invalidation, polling and other useful features of rtk query.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

// Infer the `RootState` and `AppDispatch` types from the store itself.
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
